import './Input.css';

/* ─────────────────────────────────────────────────────────────
   INPUT — Styled text input field.
   Wrap this in a <FormField> to get a label and error message.

   Props:
   - type:         'text' | 'email' | 'password' etc. (default: 'text')
   - id:           connects the input to its <label>
   - name:         used when submitting forms
   - placeholder:  hint text shown when empty
   - value:        controlled value (from useState)
   - onChange:     function called when value changes
   - error:        if truthy, applies error styling
   - autoComplete: e.g. 'email', 'current-password', 'off'
   ───────────────────────────────────────────────────────────── */
function Input({
  type = 'text',
  id,
  name,
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  autoComplete,
  min,
  max,
  readOnly,
}) {
  return (
    <input
      type={type}
      id={id}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      autoComplete={autoComplete}
      min={min}
      max={max}
      readOnly={readOnly}
      className={`input ${error ? 'input-error' : ''} ${readOnly ? 'input-readonly' : ''}`}
    />
  );
}

export default Input;
